import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const item = css`
  flex-basis: ${spacing(21.8)}; // 174px
  flex-grow: 1;
  flex-shrink: 0;
  padding-inline-end: ${spacing(0.5)}; // 4px
  padding-block-end: ${spacing(0.5)}; // 4px
`
export const skeleton = css`
  block-size: ${spacing(12.25)}; // 98px
  inline-size: 100%;
`
